const config = {
	// API_ROOT: 'https://ro-food-backend.bis-pro.com/ServiceLayer/b1s/v2/',
	API_ROOT: "https://rofood-dashboard-backend.bis-apps.com/",
};

export default config;
